import {useEffect, useState} from "preact/hooks";
import style from './style.css';
import StripeElement from '../../components/stripeElement'
import ProductDetails from '../../components/product'
import Loading from '../../components/loading'

import { getTotal } from '../../helpers'; 

import { api } from '../../graphql'
import { GET_PRODUCTS_BY_SLUG } from '../../graphql/queries'
import { ORDER_PRODUCT } from '../../graphql/mutations'

const Product = ({ slug }) => {
	const [loading, setLoading] = useState(true);
	const [products, setProducts] = useState(null)
	const [productQuantities, setProductQuantities] = useState({})
	const [stripe, setStripe] = useState(null)
	const [orderResults, setOrderResults] = useState(null)
	const [errors, setErrors] = useState(null)

	useEffect(() => {
		api({
			query: GET_PRODUCTS_BY_SLUG,
			variables: {
				slug,
				pricing: true
			}
		}).then(response => {
				if (response.errors) {
					setErrors([{
						message: "Product not found"
					}])
				} else {
					setStripe(Stripe(process.env.PREACT_APP_STRIPE_KEY, response.data.getProductsBySlug[0].owner.stripe_user_id))
					setProducts(response.data.getProductsBySlug)
					document.title = `${response.data.getProductsBySlug[0].owner.company_name}: ${response.data.getProductsBySlug[0].name}`
				}
			})
			.catch(error => {
				console.log(error)
				setLoading(false)
				setErrors([{
					message: "There was an error loading this product. Please try again."
				}])
			})
			.finally(() => setLoading(false));
	}, [slug]);

	const updateQuantity = (productId, quantity) => {
		setProductQuantities({
			...productQuantities,
			[productId]: {
				...(productQuantities[productId] || {}),
				...quantity,
			}
		})
	}

	const orderProduct = (stripeData, order) => {
		return api({
			query: ORDER_PRODUCT,
			variables: {
				order,
				email: stripeData.email,
				name: stripeData.name,
				proxy_name: stripeData.proxy_name,
				zip: stripeData.stripe.card.address_zip,
				phone: stripeData.phone,
				stripe_token: stripeData.stripe.id,
				stripe_card_id: stripeData.stripe.card.id,
			}
		})
	}

	// submit order mutation
	const submitOrder = (stripeData) => {
		console.log('submit order to api', stripeData)
		setLoading(true)

		let order = []
		products.forEach(p => {
			if (productQuantities[p.id] && productQuantities[p.id].quantity > 0) {
				order.push({
					product_id: p.id,
					...productQuantities[p.id],
				})
			}
		})

		orderProduct(stripeData, order).then(results => {
			console.log('order results', results)
			if (results.errors) {
				setErrors(results.errors)
			} else {
				setOrderResults(results.data.orderProduct)
			}
		})
		.catch(error => {
			setErrors([{message: "There was an issue processing this transaction. Please try again."}])
			console.error(error)
		})
		.finally(() => {
			setLoading(false)
		})
	}

	if (loading) return <Loading />

	const renderOrderResults = () => {
		return (
			<div class={style.profile}>
				<h2>{products[0].raffle_is_live ? "You're on the list!" : "Success!"}</h2>

				{orderResults.map(r => {
					const product = products.find(p => p.id == r.product_id)
					return (
						<div>
							{r.error && (
								<div class={style.error}>Error {product.name}: {r.error}</div>
							)}
							{!r.error && (
								<div>
									Order <b>#{r.id}</b>: {r.quantity} x {product.name}
								</div>
							)}
							
						</div>
					)
				})}

				{products[0].raffle_is_live && 
					<div>
						<p>
							At the conclusion of the raffle, all successful entries will receive an email confirming their order. Good luck!<br/>
							<br/>
							Note: Your credit card will only be charged if your entry is randomly selected.
						</p>
						<p>
							Keep an eye on your email at {orderResults[0].email} for confirmation of the order after the raffle runs.
						</p>
					</div>
				}
			</div>
		)
	}

	const renderToolbar = () => {
		const onSale = products ? new Date(products[0].on_sale) : new Date()
		const totals = getTotal(products, productQuantities);
		return (
			<div class={style.toolbar}>
				{ new Date() < onSale &&
					<div><b>On Sale:</b> {onSale.toLocaleString()}</div>
				}

				{ new Date() > onSale && 
					<div>
						<button style="float:right;" onClick={() => document.querySelector('#checkout-form').scrollIntoView({ behavior: 'smooth', block: 'center' })}>Checkout</button>
						<div><b>Total: </b> {totals.total.toFixed(2)}</div>
					</div>
				}
			</div>
		)
	}

	const renderForm = () => {
		const onSale = products ? new Date(products[0].on_sale) : new Date()

		return (
			<>
				<div><b>On Sale: {onSale.toLocaleString()}</b></div>
				<br/>
				{products && products[0].raffle_minutes > 0 && products[0].raffle_is_live &&
					<div>
						To ensure everyone has a fair chance, submissions will be accepted for {products[0].raffle_minutes} minutes after the on sale time. <br/>
						Once the raffle period has elapsed, entries will be selected at random and cards will be charged.
						You will receive an email verifying your order if successful.<br/>

						{products[0].dynamic_quantities && 
							<p>
								This is a raffle with dynamic quantities.<br/>
								The maximum number of bottles available per individual will be determined based on 
								the number of individuals that submit and their requested quantities.
							</p>
						}
						<br/>
					</div>
				}
				{errors && errors.map(e =>
					<div>
						<div class={style.error}>{e.message}</div>
					</div>
				)}
				{new Date() > onSale && stripe &&
					<StripeElement stripe={stripe} onCardSuccess={submitOrder} products={products} quantities={productQuantities} />
				}
				{errors && errors.map(e =>
					<div>
						<div class={style.error}>{e.message}</div>
						<div style="padding:10px;">
							Click <a href='javascript:window.location.reload()'>here</a> to try again
						</div>
					</div>
				)}
			</>
		)
	}

	return (
		<>
			{renderToolbar()}

			<div class={style.profile}>
				{orderResults && renderOrderResults()}

				<div class={style['product-container']}>
					{products && products.map(p => (
						<ProductDetails
							product={p}
							quantityChanged={updateQuantity} 
							showQuantity={!orderResults}
						/>
					))}
				</div>

				{!orderResults && renderForm()}
			</div>
		</>
	);
}

export default Product;
